import './index.css';

const Header = () => {
    return (
        <header className='header'>
            <p>郑和公园AR体验</p>
        </header>
    )
};

export default Header;